import React from "react";

export const Header = () => {
  return (
    <header
      data-testid="site-header"
      className="fixed top-0 inset-x-0 z-50 backdrop-blur-xl bg-[#F9F8F6]/70 border-b border-[#D9D0C1]/60"
    >
      <div className="max-w-[1440px] mx-auto px-6 sm:px-12 lg:px-20 h-16 flex items-center justify-between">
        <a href="#top" className="flex items-baseline gap-3" data-testid="brand-link">
          <span className="font-display text-2xl tracking-tighter text-aio-ink">
            A.I.O
          </span>
          <span className="hidden sm:inline text-[10px] uppercase tracking-[0.28em] text-aio-soft">
            All In One Sourcing Specialists
          </span>
        </a>
        <nav className="flex items-center gap-8 text-xs uppercase tracking-[0.22em] text-aio-soft">
          <a href="#catalog" className="hidden md:inline hover:text-aio-ink transition-colors" data-testid="nav-catalog">
            Catalog
          </a>
          <a href="#reserve" className="hidden md:inline hover:text-aio-ink transition-colors" data-testid="nav-reserve">
            Reserve
          </a>
          <a
            href="#reserve"
            data-testid="header-cta-button"
            className="px-4 py-2 bg-aio-olive text-aio-bg hover:bg-aio-oliveDeep transition-colors"
          >
            Request Brochure
          </a>
        </nav>
      </div>
    </header>
  );
};
